import {
  CreateStep8Body,
  StepToReturnStep8Enum,
} from "../../../types/cto/step8";
import { MOCK_LONG_TEXT } from "../genericMocks";

export const dataStep8Body: CreateStep8Body = {
  wos_closed: true,
  step_to_return: StepToReturnStep8Enum.STEP_7,
  closure_approved: true,
  closure_approval_comment: MOCK_LONG_TEXT,
  draft: false,
};
